import React, { FC, useState } from "react";
import { ISwitchDevice } from "../../ts/interfaces/switch_device";
import {
   AlertDialog,
   AlertDialogBody,
   AlertDialogCloseButton,
   AlertDialogContent,
   AlertDialogFooter,
   AlertDialogHeader,
   AlertDialogOverlay,
   Button,
   IconButton,
   useDisclosure,
   useToast,
} from "@chakra-ui/react";
import axios from "axios";
import { IoIosRefresh } from "react-icons/io";

export const RefreshSwitchDevice: FC<{
   switchDevice: ISwitchDevice;
   onRefresh: () => void;
}> = ({ switchDevice, onRefresh }) => {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const cancelRef = React.useRef<HTMLButtonElement | null>(null);
   const [load, setLoad] = useState(false);
   const toast = useToast();

   return (
      <>
         <IconButton
            icon={<IoIosRefresh />}
            aria-label={"Add"}
            onClick={() => {
               setLoad(false);
               onOpen();
            }}
            colorScheme="blue"
         />
         <AlertDialog
            motionPreset="slideInBottom"
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            isOpen={isOpen}
            isCentered
         >
            <AlertDialogOverlay />

            <AlertDialogContent>
               <AlertDialogHeader>
                  Refresh switch device {switchDevice.name}?
               </AlertDialogHeader>
               <AlertDialogCloseButton />
               <AlertDialogBody>
                  Are you sure? You can't undo this action afterwards.
               </AlertDialogBody>
               <AlertDialogFooter>
                  <Button ref={cancelRef} onClick={onClose}>
                     Cancel
                  </Button>
                  <Button
                     colorScheme="blue"
                     ml={3}
                     isLoading={load}
                     onClick={() => {
                        setLoad(true);
                        axios
                           .post(
                              `/admin/switch-device/${switchDevice.id}/refresh`
                           )
                           .then(() => {
                              setLoad(false);
                              toast({
                                 title: `Refresh success`,
                                 position: "top",
                                 status: "success",
                                 isClosable: true,
                              });
                              onRefresh();
                           })
                           .catch((error) => {
                              let res = error.response;
                              if (res) {
                                 toast({
                                    title: res.data.message,
                                    status: "error",
                                    position: "top",
                                    isClosable: true,
                                 });
                              }
                           })
                           .finally(() => onClose());
                     }}
                  >
                     Refresh
                  </Button>
               </AlertDialogFooter>
            </AlertDialogContent>
         </AlertDialog>
      </>
   );
};
